export const NO_TOUCH_PURCHASE_MODAL_STATE = {
    Form: "form",
    InProgress: "in progress",
    Success: "success",
    Error: "error",
    PaymentFailure: "payment_failure",
} as const;

export type NoTouchPurchaseModalState =
    (typeof NO_TOUCH_PURCHASE_MODAL_STATE)[keyof typeof NO_TOUCH_PURCHASE_MODAL_STATE];
